import { FC } from "react"
import { Button, LinkBaseProps } from "@mui/material"

import { PhoneIcon } from "components/icons"
import { useTranslation } from "providers/i18n"
interface ICallButtonProps extends LinkBaseProps {
  phoneNumber?: string
  label?: string
  startIcon?: React.ReactNode
}

export const CallButton: FC<ICallButtonProps> = ({
  phoneNumber,
  label = "Call",
  startIcon = <PhoneIcon />,
  ...props
}) => {
  const { t } = useTranslation()

  return (
    <Button
      variant="outlined"
      target="_top"
      rel="noopener noreferrer"
      href={`tel:${phoneNumber}`}
      startIcon={startIcon}
      {...props}
    >
      {t(label)}
    </Button>
  )
}
